import { ConsumerJsonModel } from '../consumer.json.model';

export namespace ConsumerActions {
  export class Add {
    static readonly type = getActionName('Add Consumer');

    constructor(readonly payload: ConsumerJsonModel) {
    }
  }

  export class Edit {
    static readonly type = getActionName('Edit Consumer');

    constructor(readonly payload: ConsumerJsonModel) {
    }
  }

  export class Delete {
    static readonly type = getActionName('Delete Consumers');

    constructor(readonly payload: ConsumerJsonModel) {
    }
  }

  export class Fetch {
    static readonly type = getActionName('Fetch Consumers');
  }

  export class FetchAll {
    static readonly type = getActionName('Fetch all Consumers');
  }

  export class FetchAppend {
    static readonly type = getActionName('Fetch Consumers and append');
  }

  export class FetchSuccess {
    static readonly type = getActionName('Fetch Consumers success');

    constructor(readonly payload: ConsumerJsonModel[]) {
    }
  }

  export class FetchSuccessAppend {
    static readonly type = getActionName('Fetch success append Consumers');

    constructor(readonly payload: ConsumerJsonModel[]) {
    }
  }

  function getActionName(type: string) {
    return `[Consumer] ${type}`;
  }
}
